import type { NextPage } from "next";
import { useTranslation } from "next-i18next/pages";
import SubpageShell from "components/common/SubpageShell";
import {
  CMS_REVALIDATE_SECONDS,
  serverSideCmsTranslations
} from "lib/cms/translations";
import styles from "../../styles/accessibility/Accessibility.module.css";

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideCmsTranslations(locale, ["common", "accessibility"]))
    },
    revalidate: CMS_REVALIDATE_SECONDS
  };
}

const AccessibilityPage: NextPage = () => {
  const { t } = useTranslation("accessibility");
  const measures: string[] = t("content.measures.items", {
    returnObjects: true
  }) as string[];

  return (
    <SubpageShell
      title={t("global.websiteTitle")}
      description={t("global.websiteDescription")}
      heading={t("header.title")}
      subtitle={t("header.subtitle")}
      path="/accessibility"
    >
      <div className={styles.mainContent}>
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t("content.commitment.title")}
          </h2>
          <p className={styles.sectionText}>{t("content.commitment.text")}</p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t("content.standards.title")}
          </h2>
          <p className={styles.sectionText}>{t("content.standards.text")}</p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>{t("content.measures.title")}</h2>
          <ul className={styles.measuresList}>
            {measures.map((item: string, index: number) => (
              <li key={index} className={styles.measureItem}>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>{t("content.feedback.title")}</h2>
          <p className={styles.sectionText}>
            {t("content.feedback.text")}{" "}
            <a
              className={styles.emailLink}
              href={"mailto:" + t("content.feedback.email")}
            >
              {t("content.feedback.email")}
            </a>
          </p>
        </div>

        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            {t("content.thirdParty.title")}
          </h2>
          <p className={styles.sectionText}>{t("content.thirdParty.text")}</p>
        </div>

        <p className={styles.lastUpdated}>{t("content.lastUpdated")}</p>

        <div className={styles.ctaSection}>
          <h3 className={styles.ctaTitle}>{t("cta.title")}</h3>
          <a
            className={styles.ctaButton}
            href={"mailto:" + t("content.feedback.email")}
          >
            {t("cta.button")}
          </a>
        </div>
      </div>
    </SubpageShell>
  );
};

export default AccessibilityPage;
